export const TABS = {
  all: 'all',
  sameEra: 'sameEra',
  sameBrand: 'sameBrand',
  price: 'price',
};
